import gql from 'graphql-tag';

const ACTIVE_PAYMENT_PROVIDER = gql`
  query ActivePaymentProvider {
    activePaymentProvider {
      id
      name
      is_active
    }
  }
`;

const ACTIVE_PAYMENT_PROVIDERS = gql`
  query ActivePaymentProviders {
    activePaymentProviders {
      id
      name
      is_active
    }
  }
`;

const INTERSWITCH_CHARGES = gql`
  query InterswitchCharges {
    interswitchCharges {
      cardCharge
      otherCharge
    }
  }
`;

// Config-state for the payments setup UI. Returns which required fields are
// present/missing per provider — never the stored (secret) values themselves.
const PAYMENT_PROVIDER_STATUS = gql`
  query PaymentProviderStatus {
    paymentProviderStatus {
      name
      isConfigured
      missingFields
      fields {
        key
        label
        required
        secret
        present
      }
    }
  }
`;

export { ACTIVE_PAYMENT_PROVIDER, ACTIVE_PAYMENT_PROVIDERS, INTERSWITCH_CHARGES, PAYMENT_PROVIDER_STATUS };
